// extracted by mini-css-extract-plugin
export default {"baseFiltros":"AgregarItemFiltro_baseFiltros__lvyao","tituloCampo":"AgregarItemFiltro_tituloCampo__GV1r7","mensaje":"AgregarItemFiltro_mensaje__McYtL"};